import {
  WorkflowAction,
  WorkflowFilters,
  WorkflowsManagerProps,
} from "./types";

export const transformUIActionsToAPI = (actions) => {
  return actions.map((action, index) => {
    const isFirstAction = index === 0;

    const apiAction = {
      sequence_order: action.sequenceOrder || index + 1,
      channel_type: action.channelType || action.channel,
      source: action.source || "inline",

      // Handle message source
      message_source: {
        type: action.source === "template" ? "TEMPLATE" : "CUSTOM",
        template_id:
          action.source === "template" && action.templateId
            ? parseInt(action.templateId)
            : null,
        content:
          action.source === "inline"
            ? {
                subject: action.subject || "",
                body: action.content || "",
              }
            : null,
      },

      // Handle channel specific config
      channel_specific_config: {
        cc:
          action.channelSpecificConfig?.cc ||
          (action.cc ? action.cc.split(",").map((email) => email.trim()) : []),
        bcc:
          action.channelSpecificConfig?.bcc ||
          (action.bcc
            ? action.bcc.split(",").map((email) => email.trim())
            : []),
      },

      // Fix: Properly handle time_delay - only for non-first actions
      time_delay:
        !isFirstAction && action.delay
          ? {
              value: action.delay.value,
              unit: action.delay.unit,
            }
          : null,

      is_active: true,
    };

    return apiAction;
  });
};

export const buildWorkflowFilters = (
  statusFilter?: WorkflowsManagerProps["statusFilter"]
): Partial<WorkflowFilters> => {
  switch (statusFilter) {
    case "active":
      return {
        isDraft: false,
        isActive: true,
      };
    case "draft":
      return {
        isDraft: true,
        isActive: false,
      };
    case "all":
      return {};
    default:
      return {};
  }
};
